/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function PlusIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M21.5 8.5v10h10c.813 0 1.5.688 1.5 1.5 0 .875-.687 1.5-1.5 1.5h-10v10c0 .875-.687 1.5-1.5 1.5-.875 0-1.5-.625-1.5-1.5v-10h-10c-.875 0-1.5-.625-1.5-1.5 0-.812.625-1.5 1.5-1.5h10v-10c0-.812.625-1.5 1.5-1.5.813 0 1.5.688 1.5 1.5"/>}
        </IconWrapper>);
}
